<template>
  <button
    class="reaction-button"
    :class="{ 'reaction-button--condensed': isCondensed }"
    @click="handleReactionButtonClick"
  >
    <icon-component
      v-if="selectedReaction"
      :key="selectedReaction"
      :name="reactionName"
      :class="`reaction-button__icon reaction-button__icon--${selectedReaction}`"
    />
    <!-- if the user hasn't selected a reaction, the default is 'like' -->
    <icon-component
      v-else
      key="like"
      name="like"
      class="reaction-button__icon reaction-button__icon--default"
    />
    <span
      v-if="reactionCount !== 0"
      class="reaction-button__count"
    >{{ reactionCount }}</span>
    <span
      class="reaction-button__text"
    >{{ textContent }}</span>
  </button>
</template>

<script>
export default {
  name: 'ReactionButton',
  props: {
    reactionCount: {
      type: Number,
      required: true,
    },
    selectedReaction: {
      type: String,
      default: '',
    },
    contentType: {
      type: String,
      required: true,
    },
    isCondensed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    reactionName() {
      return this.selectedReaction;
    },
    textContent() {
      if (this.reactionCount === 1) {
        return 'reaction';
      }
      return 'reactions';
    },
  },
  methods: {
    handleReactionButtonClick(event) {
      this.$snowplow.trackButtonEvent({
        data: {
          type: 'reaction',
          text: event.target.textContent.trim(),
          classes: event.target.classList,
          id: event.target.id,
        },
      });
      this.$emit('toggle-reaction-menu');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_reaction-button';
</style>

<style lang="scss"> // no scoped
  // because these styles require reaching classes of child components this must
  // be in a non-scoped style tag. There is a "deep" combinator available in vue
  // (::v-deep, /deep/, or >>>)
  // but it is not compatible with our usage of sass-loader

  .reaction-button {
    @for $i from 1 through length($reactions) {
      .reaction-button__icon--#{nth($reactions, $i)} {

        .contrast-light & {
          fill: nth($reactions-outline-colors, $i);
        }
        fill: nth($reactions-outline-colors, $i);

        .contrast-dark & {
          fill: nth($reactions-outline-colors, $i);
        }

        .reaction-icon-background {
          fill: nth($reactions-bg-colors, $i);

          .contrast-light & {
            fill: nth($reactions-bg-colors, $i);
          }

          .contrast-dark & {
            fill: nth($reactions-bg-colors, $i);
          }
        }
      }
    }
  }
</style>

<docs>

Reaction button takes a Reaction Count, and selected Reaction
(default is 'like').  It will show the Reaction Menu when clicked on.

</docs>
